import { Trans } from 'react-i18next';
import { TableRelatedDocumentsSearchDto } from '@asset-metrix/portal-gateway-client-js';
import { SidebarDocument } from '@asset-metrix/portal-ui';

import { datatableDownloadDocumentWithSignedUrl } from '../../../api/portalGateway/datatableDownloadDocument';
import { actionWithAsyncNotification } from '../../../utils/actionWithAsyncNotification';

export function downloadSidebarDocument(
  document: SidebarDocument | undefined,
  {
    isRelatedDocument,
    query,
    selection,
    widgetId,
  }: {
    isRelatedDocument?: boolean;
    query?: {
      inline?: boolean;
      parentDocumentId?: string;
      token?: string;
    };
    selection?: TableRelatedDocumentsSearchDto['selection'];
    widgetId: string;
  }
) {
  if (document == null) {
    return;
  }

  actionWithAsyncNotification(
    async () =>
      datatableDownloadDocumentWithSignedUrl({
        defaultFileName: document.fileName,
        documentId: document.id,
        isRelatedDocument,
        query,
        selection,
        widgetId,
      }),
    {
      startMessage: (
        <Trans
          i18nKey="app.notifications.documentDownload.loading"
          values={{ fileName: document.fileName }}
        />
      ),
      successMessage: (
        <Trans
          i18nKey="app.notifications.documentDownload.success"
          values={{ fileName: document.fileName }}
        />
      ),
      errorMessage: (
        <Trans
          i18nKey="app.notifications.documentDownload.error"
          values={{ fileName: document.fileName }}
        />
      ),
    }
  );
}
